import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { sendOrganizationIdentityVerification } from '@src/api'
import { DefaultApiSendOrganizationIdentityVerificationRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

import { SendOrganizationIdentityVerificationResponseError } from './type'

export const useSendOrganizationIdentityVerification = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    AxiosResponse<string>,
    AxiosResponse<SendOrganizationIdentityVerificationResponseError>,
    DefaultApiSendOrganizationIdentityVerificationRequest
  >({
    mutationFn: (
      params: DefaultApiSendOrganizationIdentityVerificationRequest
    ) => sendOrganizationIdentityVerification(axiosInstance, params),
  })
}
